import { CmhAddressPoint } from '@/models/cmh-address-point';

export interface CmhAddressState {
  addressPoint: CmhAddressPoint | null
}

export const InitialState: CmhAddressState = {
  addressPoint: null
}
